import { Component, ViewChild, ElementRef } from '@angular/core';

import { UtilidadesService } from '../../utilidades.servicios.index';
import { AccionModel, ParametroModel } from '../../utilidades.modelos.index';

@Component({
	selector: 'app-ayuda',
	templateUrl: './ayuda.component.html'
})
export class AyudaComponent {
	public Lista: AccionModel[] = [];
	public TextoABuscar: string = "";
	@ViewChild("txtBuscar") txtBuscar: ElementRef;

	constructor(
		public Utilidades: UtilidadesService
	) {
		this.Utilidades._titulo = "Documentación del API";

		this.Utilidades.Get("").subscribe(result => this.Lista = result.Resultado);
	}

	ngAfterViewInit() {
		this.txtBuscar.nativeElement.focus();
	}
}